// Auto-generated by tools/generate-build-info.mjs.
// Do not edit. This file is git-ignored and rewritten on every build.
export interface BuildInfo {
  readonly commitSha: string;
  readonly commitShortSha: string;
  readonly branch: string;
  readonly pipelineId: string | null;
  readonly pipelineUrl: string | null;
  readonly buildTime: string;
  readonly version: string;
}

export const buildInfo: BuildInfo = {
  "commitSha": "1ef4063bc9abeac27215c7340429b2e461c31eab",
  "commitShortSha": "1ef4063b",
  "branch": "test/dev-landing-plus-write-cards",
  "pipelineId": null,
  "pipelineUrl": null,
  "buildTime": "2026-11-04T00:59:23.143Z",
  "version": "0.0.0"
} as const;
